module.exports = __webpack_public_path__ + "img/img28.d056433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img28.png
// module id = 372
// module chunks = 0